export interface IProps {
    onClose(): void;
    onSuccess?(): void;
    isEmpty: boolean;
    emptyText: string;
    titleText: string;
    submitBttnText: string;
    oneFileOnly?: boolean;
}

export enum EAction {
    CREATE = 'create',
}
